<template>
  <div class="ShowIrRemote lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="ShowIrRemote-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="ShowIrRemote-main lxn-pos-rel">
      <div class="ShowIrRemote-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox titleBgColor="#dedede" bgColor="#ececec">
          <template v-slot:title>
            <span style="color: #000000;">{{output.name}}</span>
          </template>
          <template v-slot:body>
            <AcRemoteController v-if="deviceType == 0" :nodeUUID="nodeUUID" :outputIndex="outputIndex" :sendCommand="true" />
            <TvRemoteController v-if="deviceType == 1" :nodeUUID="nodeUUID" :outputIndex="outputIndex" :sendCommand="true" />
          </template>
        </TitleBox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import TitleBox from '@/components/TitleBox.vue'
import AcRemoteController from '@/components/Home/Devices/AcRemoteController.vue'
import TvRemoteController from '@/components/Home/Devices/TvRemoteController.vue'


export default {
  name: 'ShowIrRemote',
  components: {
    CustomCurve,
    TopNav,
    TitleBox,
    AcRemoteController,
    TvRemoteController
  },
  data: function () {
    return {
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      nodeUUID: Math.floor(this.$route.params.nodeUUID),
      outputIndex: Math.floor(this.$route.params.outputIndex),
    }
  },
  watch: {
  },
  computed: {
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    deviceType: function () {
      return this.output.settings.deviceType;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .ShowIrRemote-topCurve-wrapper {
    height: 200px;
  }
  .ShowIrRemote-main {
    z-index: 2;
  }
  .ShowIrRemote-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
</style>
